import React from "react";
import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const Unsupported1Widget = ({ widget, pattern }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        boxSizing: "border-box",
        color: "text.secondary",
        overflow: "hidden",
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: "1.5rem", mb: 0.5 }} />
      <Typography variant="caption" sx={{ textAlign: "center", lineHeight: 1 }}>
        Unsupported {pattern}
      </Typography>
    </Box>
  );
};

export default Unsupported1Widget;
